import * as React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { getAuthCredentails, verifyAuthCredentails } from "../../utils";
import CustomizedSnackbars from "../Shared/SnackBar";
import styled from "styled-components";

// Styled Components
const LoginContainer = styled.div`

  margin-left: 1rem;
 
  min-width: 371px;
  width: 100%;

  .optinput{
  display:flex;
  flex-direction:row;
  justify-content:flex-start;
  align-items:center;
  gap:1rem;
  margin-top:1rem;
  margin-bottom:1rem;
  }

  .soloinput{
  border-radius:44px;
  width:40px;
  height:40px;
  text-align:center;
  border:1px solid #999;
  font-size:1.2rem;
  color:rgb(35, 35, 35);
  outline:none;
  padding:0.6rem;
  font-size: 0.95rem;
  transition: border-color 0.3s ease;
  &:focus {
    border-color: #fb641c;
  }

@media (max-width: 753px) {

      width: 100%;
}

`;

const LoginHeader = styled.div`
  font-size: 1rem;
  font-weight: 400;
 
  color:rgb(40, 40, 40);
  text-align:left;
  margin-right:auto;
  width:100%;
  margin-left:1rem;
`;

const LoginInnerCont = styled.div`
  padding: 0rem 1rem 1rem 1rem;
  width:551px;

  @media (max-width: 1351px) {
width: 421px;
  }
@media (max-width: 753px) {
width: 100%;

}

  @media (max-width: 761px) {
padding: 0rem 2rem 0rem 0rem;
}
`;

const StyledGrid = styled(Grid)`
  && {
    margin-bottom: 11px;
  }
`;

const StyledButton = styled.div`

border-radius:5rem;
height:45px;
background-color:#fb641c;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
  && {
    color: white;
    margin-top: 1rem;
  }
`;

const StyledLink = styled(Link)`
  color:rgb(19, 129, 240);
  text-decoration: none;
  font-size: 1.1rem;
  &:hover {
    text-decoration: underline;
  }
`;

const StyledInput = styled.input`
  color:rgb(35, 35, 35);
  text-decoration: none;
  outline:none;
  border-radius:44px;
  width:100%;
  height:45px;
  margin-top:1rem;
  padding:.6rem;
  border:1px solid #999;
  font-size:.9rem
  padding-left:1rem;
  font-size: 0.95rem;

  &:hover {
    text-decoration: underline;
  }
`;

export default function LoginPageNew() {
  const [requestNumber, setRequestNumber] = React.useState("");
 /*  const [otpData, setOtpData] = React.useState(""); */
 const OTP_LENGTH = 6;
const [otpData, setOtpData] = React.useState(Array(OTP_LENGTH).fill(""));
  const [alertOpen, setAlertOpen] = React.useState({
    isAlert: false,
    msg: "",
    type: "",
  });
  const inputRefs = React.useRef([]);
  const [enableOTP, setEnableOTP] = React.useState(false);

  const handleRequestEmailOrPhone = (e) => {
    e.preventDefault();
    if (alertOpen?.isAlert) {
      setAlertOpen({ isAlert: false, msg: "", type: "" });
    }
    if (enableOTP) {
      setEnableOTP(false);
    }
    const value = e.target.value;
    setRequestNumber(value);
  };

  const handleVerifyOTP = (e) => {
    e.preventDefault();
    const opt = e.target.value;
    setOtpData(opt);
  };

  const submitVerifyOtp = async () => {
    
    const requestOptData = otpData.join("");
    const requestEmailorMobile = requestNumber;

    const verifyOtpResones = await verifyAuthCredentails({
      emailID: requestEmailorMobile,
      type: "login",
      userOTP: requestOptData,
    });
    const { data = "", status = 100 } = verifyOtpResones;

    if (status === 200) {
      localStorage.setItem("userToken", JSON.stringify(data));
      if (window !== undefined) {
        window.location.href = "/";
      }
    } else {
      setAlertOpen({
        isAlert: true,
        msg: "Something went wrong, try again",
        type: "error",
      });
    }
  };

  const getLoginOTP = async () => {
    const mobileOrEmail = requestNumber;
    const regexForPhone = /^([+]\d{2})?\d{10}$/;
    const regexForEmail =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    if (
      mobileOrEmail.match(regexForPhone) ||
      mobileOrEmail.match(regexForEmail)
    ) {
      setOtpData("");
      const validateEmailResonse = await getAuthCredentails({
        emailID: mobileOrEmail,
        type: "login",
      });
      const { status = 0 } = validateEmailResonse;
      const {
        response: {
          data: {
            error = "",
            errorMessage = "",
            status: errorStatus = 100,
          } = {},
        } = {},
      } = validateEmailResonse;
      if (status === 200) {
        setAlertOpen({
          isAlert: true,
          msg: "Sent Code",
          type: "success",
        });
        setEnableOTP(true);
      } else if (errorStatus === 400 && error === "Bad Request") {
        setAlertOpen({
          isAlert: true,
          msg: `${errorMessage} Create an account or Try different email`,
          type: "error",
        });
      } else {
        setAlertOpen({
          isAlert: true,
          msg: "Something went wrong, try again",
          type: "error",
        });
      }
    } else {
      setAlertOpen({
        isAlert: true,
        msg: "Invalid Email",
        type: "error",
      });
      console.log("not valid number");
    }
  };

 const handleOtpChange = (e, index) => {
  const value = e.target.value.replace(/\D/g, "");
  if (!value) return;

  const newOtp = [...otpData];
  newOtp[index] = value[0];
  setOtpData(newOtp);

  // Move focus to next input
  if (index < OTP_LENGTH - 1) {
    inputRefs.current[index + 1]?.focus();
  }
};

const handleOtpKeyDown = (e, index) => {
  if (e.key === "Backspace") {
    const newOtp = [...otpData];
    newOtp[index] = "";
    setOtpData(newOtp);

    if (index > 0 && !otpData[index]) {
      inputRefs.current[index - 1]?.focus();
    }
  }
};

  return (
    <React.Fragment>
      <LoginContainer>
        
        <LoginHeader>Login</LoginHeader>
        <LoginInnerCont>
          <div style={{ marginBottom: "11px",borderRadius:'52%' }}>
            <StyledInput
              margin="normal"
              required
            /*   style={{borderRadius:'55%'}} */
              fullWidth
              size="small"
              id="mobileOrEmail"
              label="Enter Email/Mobile number"
              name="mobileOrEmail"
              placeholder="email address..."
              autoComplete="number"
              onChange={handleRequestEmailOrPhone}
              autoFocus
            />

          </div>
          {enableOTP && (
            <div className="optinput" style={{ marginBottom: "11px" }}>
         {/*      <StyledInput
                margin="normal"
                type="number"
                required
                size="small"
                fullWidth
                name="otp"
                label="Enter OTP"
                id="otp"
                onChange={handleVerifyOTP}
                disabled={!enableOTP}
                autoComplete="otp"
              /> */}
              {[...Array(OTP_LENGTH)].map((_, index) => (
    <input
      key={index}
      ref={(el) => (inputRefs.current[index] = el)}
      type="text"
      maxLength="1"
      className="soloinput"
      value={otpData[index]}
      onChange={(e) => handleOtpChange(e, index)}
      onKeyDown={(e) => handleOtpKeyDown(e, index)}
     
    />
  ))}


            </div>
          )}
          <div style={{ marginBottom: "11px" }}>
            {!enableOTP && (
              <StyledButton
                type="submit"
                id="OTPRequest"
                fullWidth
                size="small"
                name="OTPRequest"
                variant="contained"
                onClick={getLoginOTP}
                color="login"
              >
                Login
              </StyledButton>
            )}
            {enableOTP && (
              <StyledButton
                type="submit"
                id="OTPRequest"
                fullWidth
                size="small"
                name="OTPRequest"
                variant="contained"
                onClick={submitVerifyOtp}
                color="login"
              >
                Verify
              </StyledButton>
            )}
          </div>
          <div style={{ marginBottom: "11px" }}>
            <div style={{ display: "flex", flexDirection: "row", gap: "1rem" }}>
              <div style={{ flex: 1, marginTop: "1rem" }}>
                <StyledLink to="/signup">{"Create an account"}</StyledLink>
              </div>
              <div style={{ flex: 1 }}>
                {enableOTP && (
                  <StyledLink as="button" type="button" onClick={getLoginOTP} style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}>
                    {"Request Again? "}
                  </StyledLink>
                )}
              </div>
            </div>
            <div>
              {alertOpen?.isAlert && (
                <CustomizedSnackbars
                  text={alertOpen?.msg}
                  isOpen={alertOpen?.isAlert}
                  type={alertOpen?.type}
                />
              )}
            </div>
          </div>
        </LoginInnerCont>
      </LoginContainer>
    </React.Fragment>
  );
}
